
import { AdminProfileView } from './admin/AdminProfileView'
import { TeacherProfileView } from './teacher/TeacherProfileView'

import { PersonaSwitcher } from '../../../components/PersonaSwitcher';

const Profile = () => <PersonaSwitcher
    adminView={<AdminProfileView />}
    teacherView={<TeacherProfileView />}
    centerManagerView={<AdminProfileView />}
/>

export { Profile }
